module.exports = "/_next/static/images/contact-mobile-9bd05bb255a8b9cda486e4449ab4555f.png";